<template>
    <AuthTosLayout>
        <div class="relative">
            <h2 class="mb-4 text-2xl font-bold text-black">Terms, Conditions & Policies</h2>
            <p class="pb-14">Before moving forward on the investment process, please carefully review the documents below.</p>

            <div class="flex items-center mb-6 space-x-10 sm:space-x-20">
                <span @click="scrollTab('terms')" class="block font-bold text-gray-400 cursor-pointer" :class="{'text-black': reviewTab == 'terms'}">Terms and Conditions</span>
                <span @click="scrollTab('disclosure')" class="block font-bold text-gray-400 cursor-pointer" :class="{'text-black': reviewTab == 'disclosure'}">EFT Disclosure</span>
                <span @click="scrollTab('privacy')" class="block font-bold text-gray-400 cursor-pointer" :class="{'text-black': reviewTab == 'privacy'}">Privacy Policy</span>
            </div>

            <div @scroll="handleScroll" ref="reviewAgreement" class="h-screen sm:h-[530px] overflow-y-auto mb-8 space-y-6" :class="{'mb-[200px]': isMobile}">
                <div ref="termsCopy">
                    <terms-copy></terms-copy>
                </div>

                <div ref="disclosureCopy">
                    <disclosure-copy></disclosure-copy>
                </div>

                <div ref="privacyCopy">
                    <privacy-copy></privacy-copy>
                </div>
            </div>

            <div :class="{'fixed bottom-0 left-0 w-full bg-white py-6 terms-action': isMobile}">
                <div :class="{'container': isMobile}">
                    <checkbox-field v-model="form.reviewed">I have read the terms, conditions and policies.</checkbox-field>

                    <div class="flex justify-end space-x-6 mt-14" :class="{'!mt-3': isMobile}">
                        <app-button @click="handleNext" :busy="form.busy">Next</app-button>
                    </div>
                </div>
            </div>

            <div class="w-full h-20"></div>
        </div>
    </AuthTosLayout>
</template>

<script>
import AuthTosLayout from '@/Layouts/AuthTos'
import TermsCopy from '@/Pages/Auth/Terms'
import PrivacyCopy from '@/Pages/Auth/Privacy'
import DisclosureCopy from '@/Pages/Auth/EFTDisclosure.vue'
import CheckboxField from '@Fields/Checkbox'
import AppButton from '@/Components/Button.vue'
import { computed, onMounted, ref, defineComponent } from 'vue'
import useForm from '@/form'
import { useWindowSize } from '@vueuse/core'

export default defineComponent({
    components: {
        AuthTosLayout,
        TermsCopy,
        PrivacyCopy,
        DisclosureCopy,
        CheckboxField,
        AppButton
    },
    setup(){
        const form = useForm()
        const reviewTab = ref('terms')
        const reviewAgreement = ref(null)
        const termsCopy = ref(null)
        const disclosureCopy = ref(null)
        const privacyCopy = ref(null)

        const isMobile = computed(() => {
            const { width } = useWindowSize()

            return width.value < 576
        })

        function scrollTab(tab){
            if (tab == reviewTab.value) {
                return false
            }

            reviewTab.value = tab

            var tabDivPosition = 0

            switch(tab){
                case 'disclosure':
                    tabDivPosition = disclosureCopy.value.offsetTop - 240
                    break;
                case 'privacy':
                    tabDivPosition = privacyCopy.value.offsetTop - 240
                    break;
            }

            reviewAgreement.value.scrollTop = tabDivPosition
        }

        function isElementVisible (el, holder) {
            const { top, bottom, height } = el.getBoundingClientRect()
            const holderRect = holder.getBoundingClientRect()

            return top <= holderRect.top ? holderRect.top - top <= height : bottom - holderRect.bottom <= height
        }

        function handleScroll(evt){
            if (isElementVisible(termsCopy.value, reviewAgreement.value)) {
                reviewTab.value = 'terms'
            }

            if (isElementVisible(disclosureCopy.value, reviewAgreement.value)) {
                reviewTab.value = 'disclosure'
            }

            if (isElementVisible(privacyCopy.value, reviewAgreement.value)) {
                reviewTab.value = 'privacy'
            }
        }

        function handleNext(){
            form.post(route('login')).then(response => {
                window.location.href = route('index');
            })
        }

        return {
            form,
            reviewTab,
            reviewAgreement,
            termsCopy,
            disclosureCopy,
            privacyCopy,
            isMobile,
            scrollTab,
            handleScroll,
            handleNext
        }
    }
})
</script>
